/**
 * FF AI Agent module - English translations
 * PR1: three-pane shell + Onboarding empty state
 */
export const agentEn = {
  title: 'FF AI Agent',
  tagline: 'Project lookup · Approval submission · Knowledge Q&A — your work copilot',

  nav: {
    newSession: 'New session',
    history: 'History',
    empty: 'No sessions yet',
    groups: {
      today: 'Today',
      past7: 'Past 7 days',
      past30: 'Past 30 days',
      older: 'Older',
    },
  },

  context: {
    title: 'Context',
    empty: 'Relevant context (projects, knowledge base, approval templates) will appear once a session starts.',
  },

  composer: {
    placeholder: 'Ask something, or describe what you want to do…',
    send: 'Send',
    stop: 'Stop',
    cancel: 'Cancel',
    hint: 'Enter to send, Shift+Enter for newline',
    disclaimer: 'FF AI can make mistakes. Check important info.',
  },

  msgActions: {
    copy: 'Copy',
    copied: 'Copied',
    retry: 'Retry',
    edit: 'Edit',
    resubmit: 'Save & resubmit',
  },

  emptyHero: {
    heading: "What's on your mind today?",
    chipsHint: 'Try a scenario:',
  },

  artifact: {
    title: 'Artifacts',
    close: 'Close',
  },

  personas: {
    sectionTitle: 'Agents',
    newPersona: 'New agent',
    namePlaceholder: 'Agent name (e.g. Contract reviewer)',
    descriptionPlaceholder: 'One-line description',
    instructionsPlaceholder: 'How it should work (system prompt)…',
    create: 'Create',
    cancel: 'Cancel',
    delete: 'Delete',
    hide: 'Hide',
    deleteConfirm: 'Delete "{name}"?',
    hideConfirm: 'Built-in agents cannot be deleted. Hide "{name}"?',
    systemBadge: 'Built-in',
    empty: 'No agents yet',
  },

  memory: {
    sectionTitle: 'Memory',
    add: 'Add memory',
    placeholder: 'Record a fact or preference about you (e.g. prefer Chinese, works at EAI)…',
    save: 'Save',
    cancel: 'Cancel',
    empty: 'No memories yet. Agent will read them automatically once added.',
    deleteConfirm: 'Delete this memory?',
    delete: 'Delete',
    hint: 'Auto-read by every chat',
    categoryLabel: 'Category',
    categories: {
      USER: 'Preference',
      FEEDBACK: 'Feedback',
      PROJECT: 'Project',
      REFERENCE: 'Reference',
    },
    sourceAiDetected: 'AI-detected',
    sourceSystem: 'Org-shared',
  },

  projects: {
    sectionTitle: 'Projects',
    newProject: 'New project',
    newProjectPlaceholder: 'Project name (e.g. Product thoughts)',
    create: 'Create',
    cancel: 'Cancel',
    deleteConfirm: 'Delete project "{name}"? Chats inside will be kept but unassigned.',
    delete: 'Delete',
    rename: 'Rename',
    unassignedLabel: 'Unassigned chats',
    allLabel: 'All chats',
    empty: 'No projects yet. Create one to group related chats.',
  },

  askUser: {
    openEndedHint: 'Type your answer below to continue…',
  },

  admin: {
    routing: {
      newRule: 'New rule',
      deleteConfirm: 'Delete rule "{name}"? This cannot be undone.',
      tableHeaders: {
        name: 'Name',
        actions: 'Actions',
      },
      empty: {
        rules: 'No rules yet',
        decisions: 'No routing decisions yet',
      },
      form: {
        name: 'Name',
        namePlaceholder: 'e.g. translation → qwen-turbo',
        priority: 'priority (smaller wins)',
        scope: 'scope',
        scopeRefId: 'scopeRefId (USER/PROJECT id; leave empty for ORGANIZATION = current org)',
        provider: 'primary.provider',
        model: 'primary.model',
        pattern: 'pattern (JSON, 5-signal match)',
        patternPlaceholder: 'e.g. {"taskType":"translation"}',
        cancel: 'Cancel',
        create: 'Create',
      },
    },
    memory: {
      title: 'Org-shared Memory',
      subtitle: 'Memories listed here are automatically injected into every chat of every user in this organization.',
      add: 'Add',
      placeholder: 'One-line fact / policy / constraint for the org (e.g. all amounts in CNY)...',
      empty: 'No org-shared memory yet',
      allCategories: 'All',
    },
  },

  onboarding: {
    heading: 'Try these prompts',
    subheading: 'Tap a card to start',
    cards: {
      projectQuery: {
        title: 'Check project status',
        prompt: 'Show me the key milestones this week for the "FF91 Mass Production Readiness" project',
        tag: 'Project lookup',
      },
      approvalSubmit: {
        title: 'File a travel request',
        prompt: 'Submit a travel request for next Wednesday to Shanghai for a partner meeting',
        tag: 'Approval submission',
      },
      knowledgeQA: {
        title: 'Ask a policy question',
        prompt: 'How is annual leave calculated? Can I carry over unused days from last year?',
        tag: 'Knowledge Q&A',
      },
    },
  },

  language: {
    label: 'Language',
    zh: '中文',
    en: 'English',
  },

  slash: {
    hint: 'Commands:',
    commands: {
      clear: { name: '/clear', description: 'Close current session and start a new one' },
      compact: { name: '/compact', description: 'Have AI compress conversation history into a summary' },
      help: { name: '/help', description: 'List all available commands' },
      plan: { name: '/plan', description: 'Switch to Plan mode (lay out plan before executing)' },
      readonly: { name: '/readonly', description: 'Switch to READ_ONLY mode (disable write actions)' },
      normal: { name: '/normal', description: 'Restore default mode' },
    },
    notFound: 'Unknown command: {cmd}. Type /help to see available commands',
    helpHeader: 'Available slash commands:',
  },
};
